// import { useMediaQuery } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import 'bootstrap/dist/css/bootstrap.min.css'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { RxHamburgerMenu } from 'react-icons/rx'
import { Link, useNavigate } from 'react-router-dom'
import { Device } from 'twilio-client'
import { CLIENT_CURRENT } from '../../constants.js'
import { useAuth } from '../../pages/hooks/useAuth'
import './Sidebar.css'

const Sidebar = () => {
  const { logout, client } = useAuth()
  const [twilioDevice, setTwilioDevice] = useState(null)
  const [data, setData] = useState()
  const [open, setOpen] = React.useState(false)

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const role = client?.role_TYPE[0]?.authority

  // const isMobile = useMediaQuery('(max-width:768px)')

  const [activeTab, setActiveTab] = useState(
    window.location.pathname === '/license'
      ? 'licenses'
      : window.location.pathname === '/gps'
        ? 'gps'
        : window.location.pathname === '/data'
          ? 'data'
          : 'chat'
  )
  const navigate = useNavigate()

  const navigateRoutes = (route) => {
    setActiveTab(route)

    if (route === 'licenses' && role === 'ROLE_ADMIN') {
      navigate('/license')
    } else if (route === 'data' && role === 'ROLE_ADMIN') {
      navigate('/data')
    } else if (route === 'chat') {
      navigate('/chat')
    } else {
      navigate('/gps')
    }
  }

  const handleLogout = () => {
    logout()
    console.log(twilioDevice)
    localStorage.setItem('breaksNRestDetails', null)
    // disconnectTwilioDevice()
    // setTwilioDevice([])
  }

  const fetchClientData = async () => {
    const token = localStorage.getItem('token')
    try {
      const response = await fetch(CLIENT_CURRENT, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok || response.status !== 200) {
        return { success: false, error: 'Invalid credentials' }
      } else {
        const responseData = await response.text()
        const deserializedData = JSON.parse(responseData)
        console.log('responseDataTestTest:', deserializedData)
        setData(deserializedData)
        return { success: true, error: null }
      }
    } catch (error) {
      console.error('Data Error: ' + error)
    }
  }

  useEffect(() => {
    fetchClientData()
    const device = new Device()
    setTwilioDevice(device)
  }, [])

  // useEffect(() => {
  //   console.log('demo:', data)
  // }, [])

  const DrawerList = (
    <div className="sidebar">
      <div className="logo">
        LOG <span>BOOK</span>
      </div>

      <div className="profile-card">
        <div className="profile-img">
          {/* <img
            src="images/user-profile.svg"
            alt="User"
            width={38}
            height={38}
          /> */}
        </div>
        <h5>
          {data?.firstName || 'N/A'} {data?.lastName || 'N/A'}
        </h5>
        <p>{data?.email || 'N/A'}</p>

        {/* Horizontal Line Below Email */}
        <hr className="profile-divider" />

        <div
          className="logout-icon"
          data-bs-toggle="modal"
          data-bs-target="#myModal"
        >
          ⏻
        </div>
      </div>

      <div className="mt-4">
        {role === 'ROLE_ADMIN' && (
          <>
            {/* Licenses */}
            <Link
              href="#"
              className={`nav-link ${activeTab === 'licenses' ? 'active' : ''}`}
              onClick={() => navigateRoutes('licenses')}
            >
              <div className="first-licenses">
                <span className="icon">
                  <img
                    src={
                      activeTab === 'licenses'
                        ? 'images/licenses-icon-active.svg'
                        : 'images/licenses-icon-inactive.svg'
                    }
                    alt="Licenses"
                    width={38}
                    height={38}
                  />
                </span>
                <span className="side-bar-txt">Licenses</span>
              </div>

              <div className="second-licenses">
                {activeTab === 'licenses' && (
                  <img
                    src={'images/right-arrow-active.svg'}
                    alt="Licenses"
                    width={20}
                    height={20}
                  />
                )}
              </div>
            </Link>
          </>
        )}

        {/* GPS */}
        <Link
          href="#"
          className={`nav-link ${activeTab === 'gps' ? 'active' : ''}`}
          onClick={() => navigateRoutes('gps')}
        >
          <div className="first-gps">
            <span className="icon">
              <img
                src={
                  activeTab === 'gps'
                    ? 'images/gps-icon-active.svg'
                    : 'images/gps-icon-inactive.svg'
                }
                alt="GPS"
                width={38}
                height={38}
              />
            </span>
            <span className="side-bar-txt">GPS</span>
          </div>
          <div className="second-gps">
            {activeTab === 'gps' && (
              <img
                src={'images/right-arrow-active.svg'}
                alt="GPS"
                width={20}
                height={20}
              />
            )}
          </div>
        </Link>

        {role === 'ROLE_ADMIN' && (
          <>
            {/* Data */}
            <Link
              href="#"
              className={`nav-link ${activeTab === 'data' ? 'active' : ''}`}
              onClick={() => navigateRoutes('data')}
            >
              <div className="first-gps">
                <span className="icon">
                  <img
                    src={
                      activeTab === 'data'
                        ? 'images/data-active.svg'
                        : 'images/data-inactive.svg'
                    }
                    alt="Data"
                    width={38}
                    height={38}
                  />
                </span>
                <span className="side-bar-txt">Data</span>
              </div>
              <div className="second-gps">
                {activeTab === 'data' && (
                  <img
                    src={'images/right-arrow-active.svg'}
                    alt="Data"
                    width={20}
                    height={20}
                  />
                )}
              </div>
            </Link>
          </>
        )}

        {/* Chat */}
        <Link
          href="#"
          className={`nav-link ${activeTab === 'chat' ? 'active' : ''}`}
          onClick={() => navigateRoutes('chat')}
        >
          <div className="first-gps">
            <span className="icon">
              <img
                src={
                  activeTab === 'chat'
                    ? 'images/chat-inactive.svg'
                    : 'images/chat-inactive.svg'
                }
                alt="Chat"
                width={38}
                height={38}
              />
            </span>
            <span className="side-bar-txt">Chat</span>
          </div>
          <div className="second-gps">
            {activeTab === 'chat' && (
              <img
                src={'images/right-arrow-active.svg'}
                alt="Chat"
                width={20}
                height={20}
              />
            )}
          </div>
        </Link>
      </div>

      {/* Logout Modal */}
      <div className="modal" id="myModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '4px' }}>
            <div className="modal-header">
              <h4 className="modal-title delete-modal-heading">Logout</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body delete-modal-sub-heading">
              Are you sure you want to logout?
            </div>

            <div className="modal-footer d-flex border-top-0">
              <Button
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px'
                }}
                data-bs-dismiss="modal"
                className="global-font py-2 fw-medium ms-0 mb-3"
                type="submit"
                onClick={() => handleLogout()}
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <>
      {/* {isMobile ? ( */}
      <div className="align-license-hamberger-btn">
        <button
          style={{
            backgroundColor: 'rgba(44, 111, 235, 1)',
            borderRadius: '50%',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
          }}
          onClick={toggleDrawer(true)}
        >
          <RxHamburgerMenu size={35} />
        </button>
        <Drawer open={open} onClose={toggleDrawer(false)}>
          {DrawerList}
        </Drawer>
      </div>
      {/*
        ) : (
          <div>{DrawerList}</div>
        )}
        */}
    </>
  )
}

export default Sidebar
